/**
 * Auth-Zustand fuer die Website — App-Haelfte des gemeinsamen Vertrags mit der
 * Website (Inline-Script im <head> von `whocan-website/src/layouts/BaseLayout.astro`).
 * Beide Systeme liegen auf derselben Origin (www.whocan.org) und lesen/schreiben
 * deshalb denselben localStorage-Key:
 *
 *   whocan.authState  (Key fehlt) → ausgeloggt
 *                     'anon'      → eingeloggt als anonymer User
 *                     'user'      → eingeloggt als registrierter User
 *
 * Geschrieben wird der Key ausschliesslich von der Auth-Subscription der App
 * (`AuthService.subscribeAuthAndDbUser`), die bei Login, Logout, Anonym-Signup
 * und App-Start gleichermassen feuert. Geloescht wird er, wenn die Subscription
 * `null` liefert oder der Website-Logout-Handler `signOut()` ausfuehrt.
 * Kein TTL, kein Timestamp (Kai-Entscheid 2026-08-04) — das Flag gilt, bis ein
 * Logout es loescht.
 *
 * 'anon' folgt der Getter-Semantik von `AuthService.isAnonymous`: ein anonymer
 * Account, der bereits eine E-Mail hinterlegt hat, zaehlt als 'user'.
 *
 * Das Flag steuert NUR die Menue-/Header-Sichtbarkeit der Website — echte
 * Autorisierung bleibt vollstaendig bei App + Firebase Rules.
 *
 * Bewusst framework-frei (kein Angular-Import), analog `lang-pref.ts`.
 */

export const AUTH_STATE_KEY = 'whocan.authState';

export type AuthStateValue = 'anon' | 'user';

/** localStorage kann werfen (Safari Private Mode, deaktivierte Cookies). */
export function writeAuthState(value: AuthStateValue): void {
    try {
        window.localStorage.setItem(AUTH_STATE_KEY, value);
    } catch (e) {
        // Ohne Speicher zeigt die Website den User als ausgeloggt — wie heute.
    }
}

export function clearAuthState(): void {
    try {
        window.localStorage.removeItem(AUTH_STATE_KEY);
    } catch (e) {
        // Ohne Speicher gibt es auch kein stehengebliebenes Flag.
    }
}
